<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>E-Pak Acquisition and Disposal System (EPADS)</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
            color: #333;
        }
        h1 {
            color: #013365;
            text-align: center;
            margin-bottom: 30px;
        }
        h2 {
            color: #013365;
            border-bottom: 2px solid #013365;
            padding-bottom: 5px;
            margin-top: 25px;
        }
        .subtitle {
            text-align: center;
            font-style: italic;
            margin-bottom: 30px;
        }
        .highlight {
            font-weight: bold;
            color: #013365;
            margin-left: 0px !important;
        }
        .logo-container {
            margin: 20px auto 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    </style>
</head>
<body>
    <div class="logo-container">
        <img src="assets/images/ppra.png" alt="PPRA Logo" style="max-width: 234px;">
    </div>
    <h1>E-Pak Acquisition and Disposal System (EPADS)</h1>
    <h2>Introduction</h2>
    
    <p>The Public Procurement Regulatory Authority (PPRA) is launching its e-Government Procurement (e-GP) system namely <span class="highlight">"e-Pak Acquisition & Disposal System (EPADS)"</span>.</p>
    
    <p>The e-Procurement system is supported under the Public Financial Management System for Accountability & Service Delivery Program for Results (PforR) project under the aegis of the World Bank.</p>
    
    <p>The e-Procurement is a web based system that shall encompass the entire procurement life cycle and record all procurement activities and related information.</p>
    
    <p>All public procurement activities shall be channelled through this e-procurement system.</p>
    
    <h2>Vision</h2>
    
    <p>The envisioned e-Procurement System is a major reform for:</p>
    <ul>
        <li>Bringing efficiency in procurement</li>
        <li>Eliminating bid rigging</li>
        <li>Strengthening transparency</li>
        <li>Achieving value for money</li>
    </ul>
    
    <p>The <span class="highlight">Public e-Government Procurement Systems</span> are known to be a giant step towards improving governance using e-Governance and is considered to be the backbone of e-Governance for any country.</p>
    
    <p>The main objective of the System is to establish a national procurement regime across Pakistan.</p>
</body>
</html>